<template>
    <!-- 台班统计 -->
    <div>
        <!-- 头部-->
        <div class="child-head">
            <!-- 标题 -->
            <div class="child-head-left float-l">
                <img src="../../assets/area_title.png" class="head-img">
                <span>台班统计</span>
            </div>
        </div>
        <!-- 内容 -->
        <div class="content content-chunk-box">
            <!-- 边角 -->
            <contentCorner>
                <!-- 内容 -->
                <div class="content-div">
                    <!-- 第一块内容-->
                    <div class="content-div-1">
                        <div class="xiaoshi">
                            <span class="text-1">{{ formatMoney(totalQty) }}</span>
                            <span>小时</span>
                            <span style=" font-size: 28px;font-weight: 900; margin: 0 5px;">/</span>
                            <span class="text-1">{{ formatMoney(totalQtyMoney) }}</span>
                            <span>万元</span>
                        </div>
                        <div class="scale-div">
                            <div class="scale-div-1">
                                <div><svg-icon icon-file-name="u476" style=" font-size: 60px;" /></div>
                                <div class="scale-div-1-text">管理机械(辆)</div>
                                <div class="scale-div-1-text2">{{ totalBranchQty }}</div>
                            </div>
                            <div class="scale-div-1">
                                <div><svg-icon icon-file-name="u629" style=" font-size: 60px;" /></div>
                                <div class="scale-div-1-text">活跃工地(人)</div>
                                <div class="scale-div-1-text2">{{ totalSubitemQty }}</div>
                            </div>
                            <div class="scale-div-1">
                                <div><svg-icon icon-file-name="u612" style=" font-size: 60px;" /></div>
                                <div class="scale-div-1-text">入网机械(人)</div>
                                <div class="scale-div-1-text2">{{ workingMachineQty }}</div>
                            </div>
                            <div class="scale-div-1">
                                <div><svg-icon icon-file-name="u483" style=" font-size: 60px;" /></div>
                                <div class="scale-div-1-text">活跃机手(人)</div>
                                <div class="scale-div-1-text2">{{ totalDriverQty }}</div>
                            </div>
                        </div>
                    </div>
                    <!-- 第二块 -->
                    <div class="content-div-2">
                        <div class="content-div-2-tab">
                            <div @click="selTab(0)" :class="tabIndex == 0 ? 'border-tab' : ''">月日统计</div>
                            <div @click="selTab(1)" :class="tabIndex == 1 ? 'border-tab' : ''">城市运行</div>
                        </div>
                        <div class="content-div-2-1" v-show="tabIndex == 0">
                            <div class="operation">
                                <div class="content-div-2-title">今日运行情况</div>
                                <div>
                                    <toDayOperationEchart />
                                </div>
                            </div>
                            <div class="duration">
                                <div class="content-div-2-title">月工作情况(时长)</div>
                                <div>
                                    <monthWorkEchart />
                                </div>
                            </div>
                        </div>
                        <div class="content-div-2-2" v-if="tabIndex == 1">
                            <div class="content-div-2-2-title">近1个月城市运行情况</div>
                            <div class="city-box">
                                <dv-scroll-board class="dv-scr-board" :config="config" />
                            </div>

                        </div>
                    </div>
                </div>
            </contentCorner>

        </div>
    </div>
</template>
<script>
import contentCorner from '../../components/common/contentCorner.vue';
import { universalQueryResult, totalDriver } from '../../api/holdMy.js';
import toDayOperationEchart from '../../components/toDayOperationEchart';
import monthWorkEchart from '../../components/monthWorkEchart';
import { formatMoney } from '../../utils';
export default {

    data() {
        return {
            refreshTabing: null,
            refreshScaleing: null,   // 规模刷新定时器
            tabIndex: 0,
            totalBranchQty: 0,
            totalSubitemQty: 0,
            workingMachineQty: 0,
            totalDriverQty: 0,
            transportTotalByCityQty: [],
            lastTotalQty: 198600,
            totalQty: 0,
            totalQtyMoney: 0,
            config: {
                header: ['城市', '工作台数', '工作时长', '每日工作', '每日有效'],
                data: [],
                rowNum: 4, //表格行数
                headerHeight: 35,
                headerBGC: 'rgba(26, 201, 255, 0.2980392156862745)', //表头
                oddRowBGC: 'rgba(26, 201, 255, 0)', //奇数行
                evenRowBGC: 'rgba(26, 201, 255, 0', //偶数行
                align: ['left', 'right', 'right', 'right', 'right']
            }
        }
    },
    components: { contentCorner, toDayOperationEchart, monthWorkEchart },
    created() {
        this.refreshTab();
        this.refreshScale();

    },
    mounted() {

    },

    beforeDestroy() {
        clearInterval(this.refreshTabing);
        clearInterval(this.refreshScaleing);
    },
    methods: {
        formatMoney,
        // 自动切换tab
        refreshTab() {
            this.selTab(0);
            if (this.refreshTabing) {
                clearInterval(this.refreshTabing);
            }
            this.refreshTabing = setInterval(() => {
                var index = this.tabIndex + 1;
                if (index > 1) {
                    index = 0
                }
                this.tabIndex = index;
                this.selTab(this.tabIndex)
            }, 1000 * 60 * 3)
        },
        selTab(index) {
            this.tabIndex = index;
            if (index == 1) {
                this.getCityMonthOperation();
            }
        },
        // 刷新规模数据 30 * 57 * 1000 半个小时
        refreshScale() {
            this.getUniversalQueryResult();
            this.getUniversalQueryResult2();
            this.getUniversalQueryResult3();
            this.getCtalDriver();
            this.getClassSumHour();
            if (this.refreshScaleing) {
                clearInterval(this.refreshScaleing);
            }
            this.refreshScaleing = setInterval(() => {
                this.getUniversalQueryResult();
                this.getUniversalQueryResult2();
                this.getUniversalQueryResult3();
                this.getCtalDriver();
                this.getClassSumHour();
            }, 1000 * 60)
        },
        // 大数据台班总小时
        getClassSumHour() {
            universalQueryResult("大数据台班总小时").then(res => {
                if (res.result == 0) {
                    this.totalQty = res.rows[0].totalHour;
                    var gap = this.totalQty - this.lastTotalQty;
                    this.lastTotalQty = res.userdata;
                    this.totalQtyMoney = (this.totalQty * 130) / 10000;
                }
            }).catch(error => {
                console.log(error);
            })
        },
        // 管理机械(辆)
        getUniversalQueryResult() {
            universalQueryResult("大数据管理机械总数").then(res => {
                if (res.result == 0) {
                    this.totalBranchQty = res.rows[0].count;
                }
            }).catch(error => {
                console.log(error);
            })
        },
        // 活跃工地(人)
        getUniversalQueryResult2() {
            universalQueryResult("大数据台班工地总数").then(res => {
                if (res.result == 0) {
                    this.totalSubitemQty = res.rows[0].subitemCount;
                }
            }).catch(error => {
                console.log(error);
            })
        },
        // 入网机械(人)
        getUniversalQueryResult3() {
            universalQueryResult("大数据入网和在线机械").then(res => {
                if (res.result == 0) {
                    this.workingMachineQty = res.rows[0].netMachine;
                }
            }).catch(error => {
                console.log(error);
            })
        },
        // 活跃司机(人)
        getCtalDriver() {
            let data = {
                autoIncId: 1,
                projectType: 'A06'
            }
            totalDriver(data).then(res => {
                if (res.result == 0) {
                    this.totalDriverQty = res.userdata;
                }
            }).catch(error => {
                console.log(error);
            })
        },


        // ************近1个月城市运行情况*********
        getCityMonthOperation() {
            universalQueryResult("大数据城市台班月平均效率").then(res => {
                if (res.result == 0) {
                    let transportTotalByCityQty = res.rows;
                    var data1 = [];
                    transportTotalByCityQty.forEach(element => {
                        data1.push([element.city, element.dayCount, element.value, element.totalTime, element.effectTime])
                    });

                    this.config.data = data1;
                    this.config = { ...this.config };//关键,展开数组对象重新赋值.不写数据出不来
                }
            }).catch(error => {
                console.log(error);
            })
        }

    }
}
</script>

<style lang="scss" scoped>
.content {
    height: 380px;
}

.content-div {
    padding: 15px 0 0 20px;

    .content-div-1 {
        margin-left: 10px;
        padding-right: 20px;

        .xiaoshi {
            font-size: 18px;
            margin-bottom: 5px;

            .text-1 {
                font-size: 28px;
                font-weight: 900;
                color: rgba(128, 255, 255, 0.9882352941176471);
            }
        }

        .scale-div {
            display: flex;
            align-items: center;

            .scale-div-1 {
                width: 106px;
                height: 130px;
                background: inherit;
                background-color: rgba(26, 201, 255, 0.2980392156862745);
                border-radius: 5px;
                margin: auto;
                text-align: center;
                padding: 8px 0;

                .scale-div-1-text {
                    font-size: 16px;
                    color: #31A7FF;
                    margin-bottom: 10px;
                }

                .scale-div-1-text2 {
                    font-size: 28px;
                    font-weight: 900;
                }
            }
        }
    }

    .content-div-2 {
        height: 197px;
        display: flex;
        margin-top: 10px;
        padding-right: 10px;

        .content-div-2-tab {
            width: 7%;
            height: 190px;
            padding: auto;
            text-align: center;
            color: rgba(123, 188, 239, 0.8);
            font-weight: 400;
            font-style: normal;
            font-size: 12px;

            div {
                margin: 0 10px 10px 0;
                height: 87px;
                padding: 3px 0;
                cursor: pointer;
            }
        }

        .content-div-2-1 {
            width: 93%;
            display: flex;
            font-family: '微软雅黑', sans-serif;
            font-weight: 400;
            font-style: normal;
            font-size: 14px;
            color: #FFFFFF;
            text-align: left;

            .operation {
                width: 54%;
                margin-right: 10px;
            }

            .duration {
                width: 45%;
            }

            .content-div-2-title {
                background-color: rgba(67, 186, 254, 0.09803921568627451);
                padding: 5px 0;
                padding-left: 15px;
            }
        }

        .content-div-2-2 {
            width: 93%;
            font-family: '微软雅黑', sans-serif;
            font-weight: 400;
            font-style: normal;
            font-size: 14px;
            color: #FFFFFF;
            text-align: left;

            .content-div-2-2-title {
                width: 100%;
                background-color: rgba(67, 186, 254, 0.09803921568627451);
                padding: 5px 0;
                padding-left: 15px;
            }

            .city-box {
                overflow: hidden;
                height: 180px;

                .dv-scr-board {
                    width: 100%;
                    height: 160px;
                    font-size: 16px;
                }

            }
        }
    }
}
</style>